/** @type {import('tailwindcss').Config} */
module.exports = {
    corePlugins: {
        preflight: false,
    },
    content: [
        "./pages/**/*.{js,ts,jsx,tsx}",
        "./components/**/*.{js,ts,jsx,tsx}",
        "./hooks/**/*.{js,ts,jsx,tsx}",
    ],
    theme: {
        extend: {
            colors: {
                text: {
                    DEFAULT: "#050B20", // rgb(5, 11, 32)
                    heading: "#141414", //rgb(20, 20, 20)
                    detail: "#141414", // rgb(20, 20, 20)
                    placeholder: "#5A5A5A", // rgb(90, 90, 90)
                    disabled: "#C8C8C8", // rgb(200, 200, 200)
                    icon: "#282828", // rgb(40, 40, 40)
                    "icon-hover": "#505050", // rgb(80, 80, 80)
                },
                primary: {
                    DEFAULT: "#2B6FF4", // finance #1 (rgb(43, 111, 244))
                    finance2: "#0100C8", // finance #2 (rgb(1, 0, 200))
                    finance3: "#ECF2FF", // finance #3 (rgb(236, 242, 255))
                    text: "#FFFFFF",
                    inverted: "#000000",
                    accent: "#2B6FF4",
                    blue: "#9FD7F7",
                    green: "#00C443", // rgb(0, 196, 67)
                    yellow: "#C99E00", // rgb(201, 158, 0)
                    red: "#ED6464",
                },
                secondary: {
                    black: "#050B20",
                    white: "#FFFFFF",
                    gray: {
                        0: "#F6F6F8",
                        1: "#F4F4F4",
                        2: "#E8E8E8",
                        3: "#656565",
                        4: "#EFEFF0",
                    },
                },
                tertiary: {
                    DEFAULT: "#EEF1F4",
                },
                labels: {
                    orange: "#FF560A40",
                    yellow: "#F5E33F",
                    green: "#25CE6F",
                    babyBlue: "#C6E7FC",
                    mint: "#DCF2E3",
                    softYellow: "#F7F5CB",
                },
                accounting: {
                    green: "#038556",
                    red: "#FF560A",
                },

                background: {
                    elevated: "#FFFFFF",
                    "elevated-highlight": "#F0F0F0", // rgb(240, 240, 240)
                    "elevated-hover": "#FAFAFA", // rgb(250, 250, 250)
                    "table-highlight": "#FBFBFB", // rgb(251, 251, 251)
                    "table-header": "#FAFAFA", // rgb(250, 250, 250)

                    input: "#F6F6F8", // rgb(246, 246, 248)
                    DEFAULT: "#FFFFFF",
                    page: "#F6F6F8", // rgb(246, 246, 248)

                    light: "#EDEDED",
                    lighter: "#F2F2F2",
                    lightest: "#FFFFFF",
                },
                border: {
                    elevated: "#DBDBDB", // rgb(219, 219, 219)
                    table: "#DCDCDC", // rgb(220, 220, 220)
                },
                foreground: {
                    fill: "#282C31",
                    stroke: "#4D4D4D",
                },
                category: {
                    DEFAULT: "#323337",
                },
                consolaPurple: {
                    light: "#2B6FF4",
                    mid: "#2B6FF4",
                    dark: "#2B6FF4",
                },
            },
            fontSize: {
                xxs: "10px",
                "3xs": "8px",
            },
            lineHeight: {
                zero: "0px",
            },
            strokeWidth: {
                3: "3px",
                4: "4px",
                5: "5px",
                6: "6px",
            },
            borderRadius: {
                20: "20px",
                widget: "4px",
                smd: "4px",
            },
            gridTemplateColumns: {
                trackedWalletsDesktop: "30px repeat(4, 1fr)",
                portfolioDesktopXl: "max-content auto max-content",
                portfolioDesktopLg: "auto auto",
            },
            backgroundImage: {
                "sidebar-link-active-marker":
                    "radial-gradient(50% 50% at 50% 50%, rgba(255, 255, 255, 0.3) 0%, rgba(255, 255, 255, 0) 100%), linear-gradient(321.99deg, #2B6FF4 16.25%, #2B6FF4 86.44%)",
                "bright-gradient":
                    "linear-gradient(135deg, #2B6FF4 12.29%, #2B6FF4 85.31%);",
                "bright-gradient-top-large":
                    "radial-gradient(50% 50% at 50% 50%, rgba(255, 255, 255, 0.35) 0%, rgba(255, 255, 255, 0) 100%), linear-gradient(321.99deg, #2B6FF4 16.25%, #2B6FF4 86.44%);",
            },
            boxShadow: {
                sidebar: "4px 0px 10px rgba(0, 0, 0, 0.25)",
                "dashboard-widget":
                    "-15px 10px 30px rgba(0, 0, 0, 0.3), 20px 20px 20px rgba(0, 0, 0, 0.25)",
                "non-stroke-card":
                    "-15px 10px 30px rgba(0, 0, 0, 0.3), 20px 20px 20px rgba(0, 0, 0, 0.25)",
                md: "0px 3px 10px 0px rgba(5, 11, 32, 0.15)",
                top: "0 -4px 6px -1px rgba(0,0,0,0.1), 0 -2px 4px -2px rgba(0,0,0,0.1)",
                "top-md": "0 -6px 10px -2px rgba(0,0,0,0.2)",
                "top-sm": "0 -2px 4px -2px rgba(0,0,0,0.1)",
            },
            maxHeight: {
                500: "500px",
            },
            dropShadow: {
                md: "0px 3px 10px 0px rgba(5, 11, 32, 0.15)",
            },
            spacing: {
                widgetx: "1.4em",
                widgety: "1.4em",
            },
            animation: {
                spin: "spin 15s linear infinite",
                pulse: "pulse 3s infinite cubic-bezier(0.4, 0, 0.6, 1)",
                bubblePurple:
                    "attractPurple 700ms cubic-bezier(0.3, 0.5, 0.4, 0.9) infinite alternate-reverse",
                bubblePink:
                    "attractPink 700ms cubic-bezier(0.3, 0.5, 0.4, 0.9) infinite alternate-reverse",
                "spin-faster": "spin 5s linear infinite",
                "spin-fastest": "spin 2s linear infinite",
                wiggle: "wiggle 0.5s ease-in-out 2",
                gelatine: "gelatine 0.5s cubic-bezier(0.4, 0, 0.6, 1)",
                "menu-open": "menuOpen 0.3s ease-out",
                "menu-close": "menuClose 0.3s ease-out",
                cascaderEnter: "cascaderEnter 0.2s ease-out",
                cascaderColumnEnter: "cascaderColumnEnter 0.2s ease-out",
                quickSpin: "spin 1s ease-in-out infinite",
                "modal-slide-up":
                    "modalSlideUp 0.4s cubic-bezier(0.4, 0, 0.2, 1) forwards",
                "modal-slide-down":
                    "modalSlideDown 0.4s cubic-bezier(0.4, 0, 0.2, 1) forwards",
                "modal-error-in":
                    "modalErrorIn 0.6s cubic-bezier(0.2, 0.8, 0.2, 1) forwards",
                "modal-error-out":
                    "modalErrorOut 0.6s cubic-bezier(0.2, 0.8, 0.2, 1) forwards",
            },
            keyframes: {
                pulse: {
                    "0%, 60%, 100%": {
                        transform: "scale(1)",
                    },
                    "80%": {
                        transform: "scale(1)",
                    },
                },
                attractPurple: {
                    "0%": {
                        transform: "translateX(0px)",
                    },
                    "100%": {
                        transform: "translateX(27px)",
                    },
                },
                attractPink: {
                    "0%": {
                        transform: "translateX(0px)",
                    },
                    "100%": {
                        transform: "translateX(-27px)",
                    },
                },
                wiggle: {
                    "0%, 100%": {
                        transform: "rotate(-6deg)",
                    },
                    "50%": {
                        transform: "rotate(6deg)",
                    },
                },
                gelatine: {
                    "from, to": { transform: "scale(1, 1)" },
                    "25%": { transform: "scale(0.9, 1.1)" },
                    "50%": { transform: "scale(1.1, 0.9)" },
                    "75%": { transform: "scale(0.95, 1.05)" },
                },
                menuOpen: {
                    from: {
                        height: "0",
                    },
                    to: {
                        height: "var(--radix-accordion-content-height)",
                    },
                },
                menuClose: {
                    from: {
                        height: "var(--radix-accordion-content-height)",
                    },
                    to: {
                        height: "0",
                    },
                },
                cascaderEnter: {
                    from: {
                        opacity: 0,
                        transform: "translateY(-10px)",
                    },
                    to: {
                        opacity: 1,
                        transform: "translateY(0)",
                    },
                },
                cascaderColumnEnter: {
                    from: {
                        opacity: 0,
                        transform: "translateX(-5px)",
                    },
                    to: {
                        opacity: 1,
                        transform: "translateX(0)",
                    },
                },
                modalSlideUp: {
                    "0%": {
                        transform: "translateY(0) scale(1)",
                        opacity: "1",
                        zIndex: "2",
                    },
                    "100%": {
                        transform: "translateY(-5%) scale(1)",
                        opacity: "0.5",
                        zIndex: "1",
                    },
                },
                modalSlideDown: {
                    "0%": {
                        transform: "translateY(-1%) scale(1)",
                        opacity: "0.5",
                        zIndex: "1",
                    },
                    "100%": {
                        transform: "translateY(0) scale(1)",
                        opacity: "1",
                        zIndex: "2",
                    },
                },
                modalErrorIn: {
                    "0%": {
                        transform: "translateY(-15%) scale(1)",
                        opacity: "0",
                        zIndex: "0",
                    },
                    "100%": {
                        transform: "translateY(0) scale(1)",
                        opacity: "1",
                        zIndex: "2",
                    },
                },
                modalErrorOut: {
                    "0%": {
                        transform: "translateY(0) scale(1)",
                        opacity: "1",
                        zIndex: "2",
                    },
                    "100%": {
                        transform: "translateY(-15%) scale(1)",
                        opacity: "0",
                        zIndex: "0",
                    },
                },
            },
            width: {
                "7/16": "43.75%",
            },
            height: {
                "screen/80": "80vh",
            },
            screens: {
                mac: { max: "1500px" },
                tableHeader: "1364px",
            },
        },
        fontFamily: {
            sans: ["sohne", "ui-sans-serif", "system-ui"],
        },
        fontWeight: {
            thin: 100,
            light: 200,
            normal: 300,
            medium: 400,
            semibold: 500,
            bold: 600,
        },
    },
    plugins: [],
};
